import React, {useEffect, useRef, useState} from 'react';
import block from 'bem-cn-lite';
import {Icon, Text, Button} from '@gravity-ui/uikit';
import {ArrowShapeTurnUpLeft} from '@gravity-ui/icons';

import {DEFAULT_ERROR_TITLE, RELOAD_COUNTDOWN_SECONDS, SystemErrorProps} from './types';

import './SystemError.scss';

const b = block('system-error');

export const SystemError: React.FC<SystemErrorProps> = ({
    imageSrc,
    title = DEFAULT_ERROR_TITLE,
    description,
    errorId,
    variant = 'reload',
    onBack,
    onReload,
    onHome,
    countdownSeconds = RELOAD_COUNTDOWN_SECONDS
}) => {
    const isReload = variant === 'reload';
    const [seconds, setSeconds] = useState(countdownSeconds);
    const reloadRef = useRef(onReload);
    const didAutoReloadRef = useRef(false);

    reloadRef.current = onReload;

    useEffect(() => {
        if (!isReload) {
            return undefined;
        }

        didAutoReloadRef.current = false;
        setSeconds(countdownSeconds);

        const timer = window.setInterval(() => {
            setSeconds((prev) => {
                if (prev <= 1) {
                    window.clearInterval(timer);
                    return 0;
                }

                return prev - 1;
            });
        }, 1000);

        return () => window.clearInterval(timer);
    }, [isReload, countdownSeconds]);

    useEffect(() => {
        if (!isReload || seconds > 0 || didAutoReloadRef.current) {
            return;
        }

        didAutoReloadRef.current = true;
        reloadRef.current?.();
    }, [isReload, seconds]);

    const handleHome = () => {
        if (onHome) {
            onHome();
            return;
        }

        window.location.assign('/home');
    };

    const handleReload = () => {
        if (onReload) {
            onReload();
            return;
        }

        window.location.reload();
    };

    const handleBack = () => {
        if (onBack) {
            onBack();
            return;
        }

        if (window.history.length > 1) {
            window.history.back();
            return;
        }

        handleHome();
    };

    return (
        <div className={b()}>
            <div className={b('content')}>
                <img src={imageSrc} alt="" className={b('image')} role="presentation" />

                <Text variant="subheader-2" className={b('title')}>
                    {title}
                </Text>
                <Text variant="body-2" className={b('description')}>
                    {description}
                </Text>

                <div className={b('actions')}>
                    {isReload ? (
                        <Button size="l" view="action" onClick={handleReload}>
                            {`Перезагрузить (${seconds} с)`}
                        </Button>
                    ) : (
                        <Button size="l" view="action" onClick={handleBack}>
                            <Icon data={ArrowShapeTurnUpLeft} />
                            Назад
                        </Button>
                    )}
                    <Button size="l" onClick={handleHome}>
                        На главную
                    </Button>
                </div>

                {errorId ? (
                    <Text variant="body-1" color="hint" className={b('error-id')}>
                        {`Error ID: ${errorId}`}
                    </Text>
                ) : null}
            </div>
        </div>
    );
};
